"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Services16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 2H5V4H10V2ZM10 7H5V9H10V7ZM15 12V14H5V12H15ZM3 7H1V9H3V7ZM1 2H3V4H1V2ZM3 12H1V14H3V12Z", fill: "#383F49" }),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 0.5C13 0.223858 13.2239 0 13.5 0C13.7761 0 14 0.223858 14 0.5V1.26562C14.7322 1.36651 15.3346 1.69433 15.8005 2.11333L15.2019 3.31333C14.8615 2.91333 14.216 2.56667 13.5235 2.56667C12.9836 2.56667 12.6315 2.83333 12.6315 3.19333C12.6315 3.54959 13.1085 3.65848 13.7036 3.7943C14.6898 4.01939 16 4.31845 16 5.94C16 7.00425 15.2825 7.81111 14 7.96626V9C14 9.27614 13.7761 9.5 13.5 9.5C13.2239 9.5 13 9.27614 13 9V7.95664C12.2135 7.84838 11.4892 7.50545 11 6.99333L11.6455 5.76667C12.0681 6.22 12.9014 6.66 13.6056 6.66C14.2512 6.66 14.5563 6.38 14.5563 5.98C14.5563 5.56706 14.0404 5.4492 13.4131 5.30589C12.4403 5.08365 11.1995 4.80019 11.1995 3.26C11.1995 2.31291 11.8313 1.46836 13 1.27483V0.5Z", fill: "#383F49" }));
}
function Services16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Services16Svg, Object.assign({}, svgProps)));
}
exports.default = Services16;
//# sourceMappingURL=Services16.js.map